import {Component, OnInit} from '@angular/core';
import {DataObjComponent, DataObjComponentHelper} from '../rest-service';
import {Department, DepartmentService} from '../department.service';
import {Router} from '@angular/router';
import {NotificationService} from '../notification.service';
import {UserService} from '../user.service';

@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.css']
})
export class DepartmentComponent implements OnInit, DataObjComponent<Department> {

  readonly namePlural = 'Departamentos';

  readonly editPath = '/departments/';

  readonly newPath = '/departments_new';

  helper: DataObjComponentHelper<Department>;

  constructor(private ds: DepartmentService, private router: Router, private ns: NotificationService,
              private us: UserService) {
    this.helper = new DataObjComponentHelper<Department>(ds, ns, this.us, this.router, this.editPath);
  }

  ngOnInit() {
    this.helper.onInit();
  }

}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/department/department.component.ts